import { render, staticRenderFns } from "./certAuditManageDetail.vue?vue&type=template&id=0f8284d0&scoped=true"
import script from "./certAuditManageDetail.vue?vue&type=script&lang=js"
export * from "./certAuditManageDetail.vue?vue&type=script&lang=js"
import style0 from "./certAuditManageDetail.vue?vue&type=style&index=0&id=0f8284d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8284d0",
  null
  
)

export default component.exports